/** App identifiers for analytics filtering. */
export const ANALYTIC_APPS = {
  MOBILE: "mobile",
  MARKETING: "marketing",
  WEB: "web",
} as const;

export type AnalyticApp = (typeof ANALYTIC_APPS)[keyof typeof ANALYTIC_APPS];

/** Super property keys for PostHog analytics. */
export const ANALYTIC_SUPER_PROPERTIES = {
  $APP: "$app",
  $APP_VERSION: "$app_version",
  $GIT_SHA: "$git_sha",
  $RELEASE: "$release",
  MOBILE__RELEASE: "mobile__release", // legacy
} as const;
